import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 50,
    paddingBlock: 40,
  },
  sectionTitle: {
    fontSize: 36,
    fontWeight: 700,
    fontFamily: 'Raleway',
    color: theme.palette.black,
  },
  solutionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 40,
    justifyContent: 'center',
  },
}))

export default styles
